var map = {
	"./ant_move.gif": "./src/EGRContent/Story/RukhKoRup/images/ant_move.gif",
	"./boy_swing.gif": "./src/EGRContent/Story/RukhKoRup/images/boy_swing.gif",
	"./boy_swing.png": "./src/EGRContent/Story/RukhKoRup/images/boy_swing.png",
	"./cover_banner.jpg": "./src/EGRContent/Story/RukhKoRup/images/cover_banner.jpg",
	"./cover_page.jpg": "./src/EGRContent/Story/RukhKoRup/images/cover_page.jpg",
	"./cover_page_rkr.jpg": "./src/EGRContent/Story/RukhKoRup/images/cover_page_rkr.jpg",
	"./dry_leaf.png": "./src/EGRContent/Story/RukhKoRup/images/dry_leaf.png",
	"./flowers.png": "./src/EGRContent/Story/RukhKoRup/images/flowers.png",
	"./green_leaf.png": "./src/EGRContent/Story/RukhKoRup/images/green_leaf.png",
	"./kite_fly.gif": "./src/EGRContent/Story/RukhKoRup/images/kite_fly.gif",
	"./kite_fly.png": "./src/EGRContent/Story/RukhKoRup/images/kite_fly.png",
	"./last_page_rkr.jpg": "./src/EGRContent/Story/RukhKoRup/images/last_page_rkr.jpg",
	"./musical_nodes.gif": "./src/EGRContent/Story/RukhKoRup/images/musical_nodes.gif",
	"./musical_nodes.png": "./src/EGRContent/Story/RukhKoRup/images/musical_nodes.png",
	"./page_01.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_01.jpg",
	"./page_02.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_02.jpg",
	"./page_02_a.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_02_a.jpg",
	"./page_03.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_03.jpg",
	"./page_03_a.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_03_a.jpg",
	"./page_03_branch.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_03_branch.jpg",
	"./page_04.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_04.jpg",
	"./page_04_a.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_04_a.jpg",
	"./page_05.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_05.jpg",
	"./page_05_a.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_05_a.jpg",
	"./page_05_leaf.png": "./src/EGRContent/Story/RukhKoRup/images/page_05_leaf.png",
	"./page_06.jpg": "./src/EGRContent/Story/RukhKoRup/images/page_06.jpg",
	"./panche-baja.png": "./src/EGRContent/Story/RukhKoRup/images/panche-baja.png",
	"./pink_leaf.png": "./src/EGRContent/Story/RukhKoRup/images/pink_leaf.png",
	"./raining_new.gif": "./src/EGRContent/Story/RukhKoRup/images/raining_new.gif",
	"./second_page.jpg": "./src/EGRContent/Story/RukhKoRup/images/second_page.jpg",
	"./snow_fall.gif": "./src/EGRContent/Story/RukhKoRup/images/snow_fall.gif",
	"./snow_fall.png": "./src/EGRContent/Story/RukhKoRup/images/snow_fall.png",
	"./snow_fall_500.gif": "./src/EGRContent/Story/RukhKoRup/images/snow_fall_500.gif",
	"./snow_falls.gif": "./src/EGRContent/Story/RukhKoRup/images/snow_falls.gif",
	"./story-banner.svg": "./src/EGRContent/Story/RukhKoRup/images/story-banner.svg",
	"./swing.gif": "./src/EGRContent/Story/RukhKoRup/images/swing.gif",
	"./swing.png": "./src/EGRContent/Story/RukhKoRup/images/swing.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/RukhKoRup/images sync recursive ^\\.\\/.*$";